import React, { useState, useRef } from "react";
import {
  Calendar,
  CalendarClock,
  Users,
  FileText,
  Settings,
  Home,
  Plus,
  Search,
  Bell,
  Menu,
  X,
  Stethoscope,
  ChevronDown,
  LogOut,
  Clock
} from "lucide-react";
import { ModalCita } from "../components/ModalCita";
import { notification } from "antd";

export const LayoutMain = ({ children, titleItem }) => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const perfil = JSON.parse(localStorage.getItem("auth")).perfil;
  const [nombreUser] = useState(
    JSON.parse(localStorage.getItem("auth")).nombre,
  );
  const [fecha] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp.fechas,
  );
  const [medico] = useState(JSON.parse(localStorage.getItem("auth")).medico);
  const [api, contextHolder] = notification.useNotification();
  const [activeTab, setActiveTab] = useState(titleItem);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Estado para controlar qué submenú está abierto (guardamos el id del menú)
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const toggleSubmenu = (menuId) => {
    setOpenSubmenu(openSubmenu === menuId ? null : menuId);
  };

  const modal = useRef();

  const navItems = [
    { id: "Dashboard", label: "Inicio", icon: Home },
    {
      id: "AgendaCitas",
      label: "Citas",
      icon: Calendar,
    },
    {
      id: "AgendaSemana",
      label: "Agenda Semanal",
      icon: CalendarClock,
    },
    {
      id: "PacientesMenu",
      label: "Pacientes",
      icon: Users,
      submenus: [
        {
          id: "Pacientes",
          label: "Directorio",
          icon: Users,
        },
        {
          id: "Expediente",
          label: "Expediente",
          icon: FileText,
        },
      ],
    },
    { id: "configuraciones", label: "Configuraciones", icon: Settings, submenus: [
      {
        id: "Horarios",
        label: "Horarios",
        icon: Clock
      },
      {
        id: "Servicios",
        label: "Servicios",
        icon: Settings
      }
    ] },
    { id: "cerrarSesion", label: "Cerrar Sesión", icon: LogOut },
  ];

  const deleteCookies = () => {
    document.cookie = `sessionID=;`;
    document.cookie = "expira=;";
  };

  const cerrarSesion = () => {
    localStorage.clear();
    deleteCookies();
    const auth = {
      id: 0,
      idUser: "",
      nombre: "",
      sesionIni: undefined,
    };

    localStorage.setItem("auth", JSON.stringify(auth));
    window.location = `/`;
  };

  const goToPage = (page) => {
    if (page !== "cerrarSesion") {
      if(page === 'Expediente' && perfil === 'Asistente'){
        errorNotificaction("Acceso", "El usuario no cuenta con el permiso para ingresar.");
        return;
      }
      window.location = `/#/Home/${page}`;
    } else {
      cerrarSesion();
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-800 flex flex-col md:flex-row">
      {/* Mobile Sidebar Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-slate-900/50 z-40 md:hidden backdrop-blur-sm transition-opacity"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Sidebar Navigation */}
      <aside
        className={`
        fixed md:static inset-y-0 left-0 z-50 w-64 bg-slate-900 text-slate-300 flex flex-col justify-between transition-transform duration-300 ease-in-out
        ${isSidebarOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"}
      `}
      >
        <div>
          {contextHolder}
          {/* Logo Brand Header */}
          <div className="p-5 flex items-center justify-between border-b border-slate-800">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-cyan-500 to-blue-600 flex items-center justify-center text-white shadow-lg shadow-cyan-500/20">
                <Stethoscope className="w-6 h-6" />
              </div>
              <div>
                <h1 className="font-bold text-lg text-white tracking-tight leading-none">
                  Consultorio
                </h1>
                <span className="text-xs text-cyan-400 font-medium tracking-wide">
                  DIGITAL PLATFORM
                </span>
              </div>
            </div>
            <button
              onClick={() => setIsSidebarOpen(false)}
              className="md:hidden text-slate-400 hover:text-white p-1"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Nav Items */}
          <nav className="p-4 space-y-1.5">
            <p className="px-3 text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">
              Menú Principal
            </p>
            {navItems.map((item) => {
              const Icon = item.icon;
              const hasSubmenus = item.submenus && item.submenus.length > 0;
              const isSubmenuOpen = openSubmenu === item.id;

              // El elemento está activo si coincide directamente o si uno de sus submenús está activo
              const isChildActive =
                hasSubmenus &&
                item.submenus.some((sub) => activeTab === sub.id);
              const isActive = activeTab === item.id || isChildActive;

              return (
                <div key={item.id} className="space-y-1">
                  {/* Item Principal */}
                  <button
                    onClick={() => {
                      if (hasSubmenus) {
                        toggleSubmenu(item.id);
                      } else {
                        goToPage(item.id);
                      }
                    }}
                    className={`
                      w-full flex items-center justify-between px-3.5 py-3 rounded-xl font-medium text-sm transition-all duration-200
                      ${
                        isActive && !hasSubmenus
                          ? "bg-gradient-to-r from-cyan-600 to-blue-600 text-white shadow-md shadow-blue-500/20 font-semibold"
                          : "hover:bg-slate-800/80 text-slate-400 hover:text-slate-200"
                      }
                    `}
                  >
                    <div className="flex items-center gap-3">
                      <Icon
                        className={`w-5 h-5 ${isActive ? "text-white" : "text-slate-400"}`}
                      />
                      <span>{item.label}</span>
                    </div>

                    <div className="flex items-center gap-2">
                      {item.badge !== undefined && (
                        <span
                          className={`text-xs px-2 py-0.5 rounded-full ${isActive ? "bg-white/20 text-white" : "bg-slate-800 text-slate-300"}`}
                        >
                          {item.badge}
                        </span>
                      )}
                      {hasSubmenus && (
                        <ChevronDown
                          className={`w-4 h-4 transition-transform duration-200 ${isSubmenuOpen ? "rotate-180 text-white" : "text-slate-400"}`}
                        />
                      )}
                    </div>
                  </button>

                  {/* Submenús Desplegables */}
                  {hasSubmenus && isSubmenuOpen && (
                    <div className="pl-4 pr-1 py-1 space-y-1 border-l-2 border-slate-800 ml-4">
                      {item.submenus.map((sub) => {
                        const SubIcon = sub.icon;
                        const isSubActive = activeTab === sub.id;
                        return (
                          <button
                            key={sub.id}
                            onClick={() => goToPage(sub.id)}
                            className={`
                              w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-150
                              ${
                                isSubActive
                                  ? "bg-cyan-600/20 text-cyan-400 font-semibold"
                                  : "text-slate-400 hover:text-slate-200 hover:bg-slate-800/50"
                              }
                            `}
                          >
                            <SubIcon
                              className={`w-4 h-4 ${isSubActive ? "text-cyan-400" : "text-slate-500"}`}
                            />
                            <span>{sub.label}</span>
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </nav>
        </div>

        {/* Doctor Status Footer */}
        <div className="p-4 border-t border-slate-800 bg-slate-900/60">
          <div className="flex items-center gap-3 p-2 rounded-xl bg-slate-800/50 border border-slate-700/50">
            <div className="relative">
              <img
                src="/Images/AvatarUser2.jpg"
                alt="Doctor"
                className="w-10 h-10 rounded-full object-cover border-2 border-cyan-500"
              />
              <span className="absolute bottom-0 right-0 w-3 h-3 bg-emerald-500 border-2 border-slate-900 rounded-full"></span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-white truncate">
                {nombreUser}
              </p>
              <p className="text-xs text-slate-400 truncate">
                {medico === null ? nombreUser : medico.especialidad1}
              </p>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Container */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {}
        <header className="bg-white border-b border-slate-200 sticky top-0 z-30 px-4 sm:px-6 py-3.5 flex items-center justify-between gap-4 shadow-sm">
          <div className="flex items-center gap-3 flex-1 max-w-md">
            <button
              onClick={() => setIsSidebarOpen(true)}
              className="md:hidden text-slate-600 hover:text-slate-900 p-2 rounded-lg bg-slate-100"
            >
              <Menu className="w-5 h-5" />
            </button>

            {/* Global Search */}
            <div className="relative w-full">
              <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="text"
                placeholder="Buscar pacientes, citas o expediente..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 bg-slate-100 focus:bg-white text-sm rounded-xl border border-transparent focus:border-cyan-500 focus:outline-none transition-all"
              />
            </div>
          </div>

          {/* Quick Actions Header */}
          <div className="flex items-center gap-2 sm:gap-3">
            <button
              // onClick={() => setIsCitaModalOpen(true)}
              onClick={() => modal.current.open()}
              className="hidden sm:flex items-center gap-2 bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-700 hover:to-blue-700 text-white px-4 py-2 rounded-xl text-sm font-semibold shadow-md shadow-cyan-500/10 transition-all transform active:scale-95"
            >
              <Plus className="w-4 h-4" />
              <span>Nueva Cita</span>
            </button>

            <button className="relative p-2 text-slate-600 hover:text-slate-900 rounded-xl hover:bg-slate-100 transition-colors">
              <Bell className="w-5 h-5" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-rose-500 rounded-full ring-2 ring-white"></span>
            </button>

            <div className="h-6 w-[1px] bg-slate-200 mx-1 hidden sm:block"></div>

            <div className="hidden lg:flex flex-col text-right">
              <span className="text-xs text-slate-400 font-medium">
                {fecha.fechaLarga}
              </span>
              <span className="text-xs font-semibold text-emerald-600 flex items-center justify-end gap-1">
                <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
                Consultorio Activo
              </span>
            </div>
          </div>
        </header>

        {/* Dynamic Main Body Content */}
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 bg-slate-50">
          {children}
        </main>
      </div>

      <ModalCita
        ref={modal}
        idNegocio={idNegocio}
        tipoHorario={"horarioLibre"}
        idUser={idUser}
        nuevaCita={true}
        nomPaciente={""}
      />
    </div>
  );
};
